<template>
    <div class="row scrollable events groups">
        <div class="col-12 mb-3 mt-3">
            <h3>{{ $t('pages.admin.Groups') }}</h3>
            <events-generate-group-modal :event-id="eventId"/>
        </div>
        <loading :name="loaderName">
            <div class="col-12">
                <b-table
                        striped
                        borderless
                        small
                        hover
                        :items="() => getGroupsList(eventId)"
                        @row-clicked="click"
                        :fields="fields"
                >
                </b-table>
            </div>
        </loading>
    </div>
</template>

<script>
  import {BTable} from 'bootstrap-vue/src/components/table/table';
  import {mapActions, mapGetters} from 'vuex';
  import EventsGenerateGroupModal from "../../components/events/EventsGenerateGroupModal";

  export default {
    name: "Groups",
    components: {
      EventsGenerateGroupModal,
      BTable
    },
    created() {
      this.loadContent();
    },
    data() {
      return {
        loaderName: 'load groups',
        fields: [
          {
            key: 'group_name',
            label: this.$t('fields.group'),
            sortable: false,
          },
          {
            key: 'group_animator',
            label: this.$t('fields.GroupAnimator'),
            sortable: false
          },
          {
            label: this.$t('fields.BirthDate'),
            key: 'birth_date',
            sortable: false,
            formatter: (value, field, row) => {
              return `${row.info.min} - ${row.info.max}`;
            }
          },
          {
            label: this.$t('fields.Count'),
            key: 'count',
            sortable: false,
            formatter: (value, field, row) => {
              return `${row.info.count}`;
            }
          }
        ]
      }
    },
    computed: {
      ...mapGetters(['getGroupsList']),
      eventId() {
        return this.$route.params.eventId;
      },
    },
    methods: {
      ...mapActions(['loadGroups']),
      click(group) {
        return this.$router.push('/admin/events/' + this.eventId + '/participants/?group=' + group.group_name)
      },
      loadContent() {
        this.$wait.start(this.loaderName);

        return this.loadGroups({
          eventId: this.eventId
        }).then(() => {
            this.$wait.end(this.loaderName)
          }
        )
      }
    }
  }
</script>

<style scoped>

</style>
